import { productionEndpoint, stagingEndpoint } from '@shared/config';
import { Env } from '@stencil/core';

export type ApiResponse<Data = any> = {
  status: number;
  data: Data;
  error?: string;
  message?: string;
}

export type InvokeResponse<T = any> = Pick<ApiResponse<T>, 'data' | 'message'>;

export async function invokeAPI<T = any>(
  action: string,
  params: Record<string, string> = {},
  payload?: object,
): Promise<InvokeResponse<T>> {
  const endpoint = Env.dev ? stagingEndpoint : productionEndpoint;
  const queryParams = new URLSearchParams({
    ...params,
    '[action]': action,
  });
  const url = `${endpoint}?${queryParams}`;
  const method = payload ? 'POST' : 'GET';
  const body = payload && JSON.stringify(payload, null, 2);

  const { data, error, message } = await (
    fetch(url, { method, body }).then<ApiResponse<T>>(
      results => results.json(),
    )
  );

  if (error) {
    throw error;
  }

  return { data, message };
}
